import { Injectable } from "@angular/core";
import { TreeNode } from 'primeng/api';
import { BehaviorSubject } from "rxjs";

export interface SearchParams {
    keyword: string;
    category: TreeNode[];
    country: Number[];
}

@Injectable()
export class SearchDataService {

    searchParams = new BehaviorSubject<SearchParams>({
        keyword: "",
        category: [],
        country: []
    });

    constructor() {}

    setSearchData(keywordData: string, categoryData: TreeNode[], countryData: Number[]) {
        this.searchParams.next({
            keyword: keywordData,
            category: categoryData,
            country: countryData
        })
    }

    getSearch() {
        return this.searchParams.asObservable();
    }

    resetSearchData() {
        this.searchParams.next({
            keyword: "",
            category: [],
            country: []
        })
    }
}